export { default as ShippingMethodList } from './ShippingMethodList';
export { default as ShippingMethodEdit } from './ShippingMethodEdit';


// WEBPACK FOOTER //
// ./src/modules/ShippingMethod/pages/index.ts